import React from 'react'
import { Form } from 'react-bootstrap'
import { AnnotationDataBoundingBox } from '../../../types/models/annotation'
import ClassificationReviewCard from './ClassificationReviewCard'

interface ClassificationReviewGridProps {
  items: AnnotationDataBoundingBox[]
  selectedBBoxClassIndex?: number
  showAcceptButton?: boolean
  showRejectButton?: boolean
  onAccept?: (box: AnnotationDataBoundingBox, e?: React.MouseEvent) => void
  onReject?: (box: AnnotationDataBoundingBox, e?: React.MouseEvent) => void
  onSelect?: (box: AnnotationDataBoundingBox) => void
  selectionMode?: boolean
  selectedIndices?: number[]
  onToggleSelect?: (index: number) => void
}

const ClassificationReviewGrid: React.FC<ClassificationReviewGridProps> = ({
  items,
  selectedBBoxClassIndex,
  showAcceptButton = false,
  showRejectButton = false,
  onAccept,
  onReject,
  onSelect,
  selectionMode = false,
  selectedIndices = [],
  onToggleSelect,
}) => {
  if (items.length === 0) {
    return (
      <div
        className="d-flex align-items-center justify-content-center h-100"
        style={{ color: 'rgba(255, 255, 255, 0.5)', padding: '2rem' }}
      >
        <p className="mb-0">No predictions to review</p>
      </div>
    )
  }

  return (
    <div
      className="p-3"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: '1rem',
        alignContent: 'start',
      }}
    >
      {items.map((item, index) => {
        const isSelected = selectionMode
          ? selectedIndices.includes(index)
          : item.class_index === selectedBBoxClassIndex

        return (
          <div key={item.class_index} style={{ position: 'relative' }}>
            {/* Selection checkbox in bulk mode */}
            {selectionMode && (
              <div
                style={{
                  position: 'absolute',
                  top: '12px',
                  left: '12px',
                  zIndex: 10,
                }}
              >
                <Form.Check
                  type="checkbox"
                  checked={selectedIndices.includes(index)}
                  onChange={() => onToggleSelect?.(index)}
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    transform: 'scale(1.2)',
                    cursor: 'pointer',
                  }}
                />
              </div>
            )}

            <ClassificationReviewCard
              item={item}
              isSelected={isSelected}
              showAcceptButton={showAcceptButton}
              showRejectButton={showRejectButton}
              onAccept={onAccept ? () => onAccept(item) : undefined}
              onReject={onReject ? () => onReject(item) : undefined}
              onClick={
                selectionMode
                  ? () => onToggleSelect?.(index)
                  : onSelect
                  ? () => onSelect(item)
                  : undefined
              }
            />
          </div>
        )
      })}
    </div>
  )
}

export default ClassificationReviewGrid
